/**
 * Made external to avoid circular dependencies
 */
export const paramterPreviewActionKey = 'manageParamter';
